import * as S from './CoveredSection.styles'
import VisibilityDetector from '../../../../components/VisibilityDetector/VisibilityDetector'
import {
  analytics,
  EVENT_NAMES,
} from '../../../../services/Analytics/Analytics'
import useScreenSize from '../../../../hooks/useScreenSize'
import { useTranslation } from 'react-i18next'
import TrustpilotRating from '../../../../components/TrustpilotRating/TrustpilotRating'
import { CDN_URL } from 'config/config'

export type CoveredSectionProps = {
  communicateFreeShipping: boolean
  illustrationUrls?: {
    shipping: string
    support: string
    rated: string
  }
}

const DEFAULT_ILLUSTRATION_URLS = {
  shipping: `${CDN_URL}/illustrations/homepage/Shipping.png`,
  support: `${CDN_URL}/illustrations/homepage/Support.png`,
  rated: `${CDN_URL}/illustrations/homepage/Rated.png`,
}

// Notice: the mobile version of this component is used by Mixtiles Homepage. If the UI of the photo books "covered" section
// diverges from the photos "covered" section, separate the two components
export default function CoveredSection({
  communicateFreeShipping,
  illustrationUrls = DEFAULT_ILLUSTRATION_URLS,
}: CoveredSectionProps) {
  const { t } = useTranslation()
  const isMediumScreen = useScreenSize('md')

  const urls = illustrationUrls
  // Detect if using dark variant by checking URL pattern
  const isDarkVariant = urls.shipping.includes('ShippingGray')

  const illustrations = isMediumScreen
    ? [
        {
          Illustration: S.ShippingImage,
          src: urls.shipping,
          labelKey: communicateFreeShipping
            ? 'homepage.covered.shipping'
            : 'pitch.global_shipping',
          isDarkVariant,
        },
        {
          Illustration: S.SupportImage,
          src: urls.support,
          labelKey: 'homepage.covered.support',
          isDarkVariant,
        },
        {
          Illustration: S.RatedImage,
          src: urls.rated,
          labelKey: 'homepage.covered.trustpilot',
        },
      ]
    : [
        {
          Illustration: S.SupportImage,
          src: urls.support,
          labelKey: 'homepage.covered.support',
          isDarkVariant,
        },
        {
          Illustration: S.ShippingImage,
          src: urls.shipping,
          labelKey: communicateFreeShipping
            ? 'homepage.covered.shipping'
            : 'pitch.global_shipping',
          isDarkVariant,
        },
      ]

  return (
    <VisibilityDetector
      onVisible={() => {
        analytics.track(EVENT_NAMES.HOMEPAGE_COVERED_VIEWED, {
          Source: 'Homepage',
        })
      }}
    >
      <S.Container>
        <S.ContentContainer>
          {!isMediumScreen && (
            <S.TitleContainer>
              <S.Title>{t('homepage.covered.title')}</S.Title>
              <TrustpilotRating />
            </S.TitleContainer>
          )}
          <S.IllustrationsContainer>
            {illustrations.map(
              ({ Illustration, src, labelKey, isDarkVariant }) => (
                <S.IllustrationContainer key={labelKey}>
                  <Illustration src={src} $isDarkVariant={isDarkVariant} />
                  {t(labelKey)}
                </S.IllustrationContainer>
              )
            )}
          </S.IllustrationsContainer>
        </S.ContentContainer>
        <S.Separator />
      </S.Container>
    </VisibilityDetector>
  )
}
